import React from "react";

import * as Styled from "./Footer.styles";

const Footer = () => {
  return (
    <Styled.FooterWrapper>
      <p>COPYRIGHT © 2022 DIETAI</p>
    </Styled.FooterWrapper>
  );
};

export default Footer;
